import { IntegrationKinds } from '@recruitee/integrations/types';

export const firstName = (fullName: string | null): string => (fullName || '').split(' ')[0] || '';

export const lastName = (fullName: string | null): string =>
  (fullName || '').split(' ').slice(1).join(' ');

export const fullName = (admin: { firstName: string; lastName: string } | null) =>
  admin ? `${admin.firstName} ${admin.lastName}` : '';

export const trimmedFormValue = (value: any): any => {
  if (typeof value === 'string' || value instanceof String) {
    return value.trim();
  } else if (Array.isArray(value)) {
    return value.map(trimmedFormValue);
  } else if (typeof value === 'object' && value !== null) {
    return Object.keys(value).reduce((acc, k) => {
      acc[k] = trimmedFormValue(value[k]);
      return acc;
    }, <any>{});
  } else {
    return value;
  }
};

// Should be removed after project marketplace global launch https://app.clickup.com/t/862kd0qv6
export const resolveRedirectUrl = (
  url: string,
  marketplaceViewContext: boolean,
  integrationKind?: IntegrationKinds,
): string =>
  marketplaceViewContext
    ? url.replace('/description', '/settings')
    : `${url}?open_integration=${integrationKind}`;
